<template>
    <el-dialog class="peiso-modal cashup" 
    :visible.sync="isOpen"
    :modal-append-to-body="false"
    :close-on-click-modal='false'
    :close-on-press-escape="false"
    width="90%"
    :before-close="handleClose"
    center>

        <div>
            <!-- <el-tabs v-model="activeTab" :stretch="true" @tab-click="handleActiveTab">
                <el-tab-pane label="Lunch" name="lunch">
                    <cashup-form ref="casupLunch" :reportDate="reportDate" :venueType="venueType" :type="activeTab" activeType="lunch"></cashup-form>
                </el-tab-pane>
                <el-tab-pane label="Dinner" name="dinner">
                    <cashup-form ref="casupDinner" :reportDate="reportDate" :venueType="venueType" :type="activeTab" activeType="dinner"></cashup-form>
                </el-tab-pane>
              </el-tabs> -->

              <cashup-form ref="casupDinner" :isOpen="isOpen" :reportDate="reportDate" :venueType="venueType" :type="activeTab" activeType="dinner"></cashup-form>

              <div class="d-flex align-items-center justify-content-center m-top-1rem cashup-content-flex">
                <el-button type="peiso-primary-pink-border-only" :disabled="isLoading" class="m-top-1rem uppecase" @click="saveCashup">SAVE {{ activeTab }} AND EXIT</el-button>
    
            </div>
        </div>

    </el-dialog>
</template>

<script>
import utils from '@/utils/utils';
import cashupForm from '@/components/common/form/cashupForm.vue'
export default {
    props: ['open', 'reportDate'],
    components: {cashupForm},
    data() {
        return {
            isLoading: false,
            isOpen: this.open,
            activeTab: 'dinner',
            venueType: 'bennelong'
        }
    },
    watch: {
        open() {
            this.isOpen = this.open;
        },
    },
    methods: {
        handleClose() {
            // this.$refs.casupLunch.saveCashup(false, 'lunch');
            this.$refs.casupDinner.saveCashup(false, 'dinner');

            this.isOpen = false
            this.$emit('onChangeOpen', this.isOpen)
            
        },
        handleActiveTab () {

        },

        saveCashup () {
            this.isOpen = false;

            if (this.activeTab == 'lunch') {
                this.$refs.casupLunch.saveCashup(true, 'lunch');
            } else {
                this.$refs.casupDinner.saveCashup(true, 'dinner');
            }

            this.$emit('onChangeOpen', this.isOpen)
        }
    },
    mounted() {
        // this.isOpen = true;
      
        
    }
}
</script>

<style lang='scss'>
    @import "static/scss/scrollbar.scss";
    .cashup {
        
        .uppecase {
            text-transform: uppercase !important;
        }
        .w-90 {
            width: 90px !important;
        }
    
        .w-130 {
            width: 130px !important;
        }
    
        .w-101 {
            width: 20% !important;
        }
    
        .w-102 {
            width: 18% !important;
        }
    
        .p-10 {
            padding: 10px !important;
        }
    
        .h-35 {
            height: 35px !important;
        }
    
        .el-tabs__item {
            color: var(--text-color);
            font-size: 20px;
            font-weight: 600;
            &:hover {
                color: #ffffffd0;
            }
        }
    
    
        .el-tabs__item.is-active {
            color: #EA3796;
        }
    
        .el-tabs__active-bar {
            background-color: #EA3796;
        }
    
        .el-tabs__content {
            max-height: 70vh !important;
            overflow-y: auto !important;
            padding: 30px 10px;
            &::-webkit-scrollbar {
                @extend .scrollbar;
            }
  
            &::-webkit-scrollbar-track {
                @extend .scrollbar-track;
            }
  
            &::-webkit-scrollbar-thumb {
                @extend .scrollbar-thumb;
            }
        }

        .el-input__inner {
            height: 35px !important;
            padding: 10px 15px !important;
        }

        &__row {
            &--col {
                margin-bottom: 10px;
            }
        }
        &__table {
            border: 1px solid #5F5F5F;
            margin-bottom: 20px;
            tr {
                border: 1px solid #5F5F5F;
            }

            td {
                border: 1px solid #5F5F5F;
                padding: 5px;
                color: var(--text-color);
                font-size: 13px !important;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/modal/cashup.vue